// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"54578fbd","155":"63172765","242":"9a77fcbe","436":"6f80940d","661":"4e7e2685","675":"c640249b"}[chunkId] + ".chunk.css";
};